import { render, staticRenderFns } from "./MesaNewReservaForm.vue?vue&type=template&id=19c4fd39&scoped=true"
import script from "./MesaNewReservaForm.vue?vue&type=script&lang=js"
export * from "./MesaNewReservaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4fd39",
  null
  
)

export default component.exports